import Link from "next/link";
import style from "./TagLink.module.css";

const TagLink = ({ href, children }) => {
  return (
    <Link legacyBehavior href={href}>
      <a className={style.link}>{children}</a>
    </Link>
  );
};

export default TagLink;
